import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getIcons } from "../Constant/Constant";
import LeadDbService from "../Services/LeadDbService";
import { interestLevel } from "../../Enum";

const icons = getIcons();

const LeadDetail = ({ lead }) => {
  const location = useLocation();
  const leadId = location.pathname.split("/").pop();
  console.log("Lead ID:", leadId);

  // // Handle the case where lead is null (before data is fetched)
  // if (!lead) {
  //   return <div className="text-center text-gray-700 text-xl">Loading lead details...</div>;
  // }

  const statusIcons = Object.freeze({
    Fresh: icons.freshIcon,
    "Registered Client": icons.customerIcon,
    "Follow-up": icons.interestedIcon,
    Dealing: icons.dealingIcon,
    "Deal Lost": icons.dealLostIcon,
    "Not Interested": icons.notInterestedIcon,
    Unanswered: icons.unansweredIcon,
    "Retry Suitable": icons.RetrySuitable,
  });
  const leadCharacterEmoji = Object.freeze({
    "Not Applicable": icons.NAEmoji,
    None: icons.NAEmoji,
    Excited: icons.excitedEmoji,
    Neutral: icons.neutralEmoji,
    Thinking: icons.ThinkingEmoji,
    Confused: icons.confusedEmoji,
  });
  const interestTagStyle = {
    display: "inline-block",
    padding: "0.25em 0.5em",
    margin: "0.25em",
    backgroundColor: "#399E79",
    borderRadius: "0.375rem",
    fontSize: "0.875rem",
    fontWeight: "500",
    color: "#fff",
  };

  const getBackgroundClass = (label) => {
    switch (label) {
      case "Gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "Silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "Bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "Diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };
  return (
    // <div className="w-full p-10 bg-white shadow-md rounded h-[880px] overflow-y-auto custom-scrollbar">
    //   <form className="w-full">
    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Name</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.name || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center gap-2">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Ph Number</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-1/10w py-2 p-2 xl:w-1.5/10w text-gray-700"
    //         type="text"
    //         readOnly
    //         value={`+${lead?.countryCode || ""}`}
    //       />
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-65/100w py-2 px-3 xl:w-60/100w text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.phoneNumber || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Email ID</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.emailId || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Lead Source</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.leadSource || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Assigned Team</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.assignedTeam || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Lead Owner</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.assignedUser || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Status</label>
    //       <div className="flex bg-[#F6F6F6] border rounded w-3/4 px-5 h-12 gap-5 items-center">
    //         <img
    //           className="w-10 h-10"
    //           src={icons[lead?.status] || ""}
    //           alt={lead?.status || ""}
    //         />
    //         <input
    //           className="appearance-none font-semibold cursor-default bg-[#F6F6F6] border-none w-3/4 py-2 px-3 text-gray-700"
    //           type="text"
    //           readOnly
    //           value={lead?.status || ""}
    //         />
    //       </div>
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Notes</label>
    //       <textarea
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 h-24 py-2 px-3 text-gray-700"
    //         readOnly
    //         value={lead?.notes || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Client Location</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.clientLocation || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Client Requirement</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.clientRequirement || ""}
    //       />
    //     </div>

    //     <div className="mb-8 flex items-center">
    //       <label className="w-2/4 text-gray-700 text-2xl font-bold">Payment Type</label>
    //       <input
    //         className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700"
    //         type="text"
    //         readOnly
    //         value={lead?.paymentType || ""}
    //       />
    //     </div>
    //   </form>
    // </div>

    <div className="w-full  p-10 bg-white shadow-md rounded h-[880px]  3xl:h-[985px] 4xl:h-[900px] overflow-y-auto custom-scrollbar">
      <form action="" className="w-full ">
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Name
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            readOnly
            required
            value={lead?.name?.replace(/\b\w/g, (char) => char.toUpperCase())}
          />
        </div>

        <div className="mb-8 flex items-center gap-2">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Ph Number
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-1/10w py-2 p-2 xl:w-1.5/10w text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="countryCode"
            type="text"
            readOnly
            required
            value={`+${lead?.countryCode}`}
          />
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-65/100w py-2 px-3 xl:w-60/100w text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="phoneNumber"
            type="text"
            required
            readOnly
            value={lead?.phoneNumber}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Email ID
          </label>
          <input
            className="shadow appearance-none border font-semibold cursor-default bg-[#F6F6F6] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.emailId}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Created Date
          </label>
          <input
            className="shadow appearance-none border font-semibold cursor-default bg-[#F6F6F6] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value= {lead?.createdTime}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Lead Source
          </label>
          <input
            className="shadow appearance-none border font-semibold cursor-default bg-[#F6F6F6] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.leadSource}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Assigned Team
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.assignedTeam}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Lead Owner
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.assignedUser}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="lead-quality"
          >
            Lead Quality
          </label>
          <div className="relative flex items-center w-3/4">
            <input
              className={` ${getBackgroundClass(lead?.leadQuality)} shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-full py-2 px-3 text-gray-700 leading-tight pl-12 focus:outline-none focus:shadow-outline`}
              id="lead-quality"
              type="text"
              required
              readOnly
              value={lead?.leadQuality}
            />
            <img
              className="absolute left-1 top-1/2 transform -translate-y-1/2 "
              src={
                interestLevel.find((level) => level.label === lead?.leadQuality)
                  ?.image
              }
              alt={lead?.leadQuality}
            />
          </div>
        </div>

        {/* <div className="mb-8 flex items-center">
  <label className="w-2/4 text-gray-700 text-2xl font-bold" htmlFor="interestTag">
    Interest Tag
  </label>
  <div className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 h-32 overflow-y-auto custom-scrollbar py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
    {lead?.interestTags && lead?.interestTags.map((tag, index) => (
      <span key={index} style={interestTagStyle}>{tag}</span>
    ))}
  </div>
</div> */}

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="interestTag"
          >
            Interest Location
          </label>
          <div className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 h-32 overflow-y-auto custom-scrollbar py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
            {lead?.interestedLocations &&
              lead?.interestedLocations.map((tag, index) => (
                <span key={index} style={interestTagStyle}>
                  {tag}
                </span>
              ))}
          </div>
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Status
          </label>
          <div
            className="flex bg-[#F6F6F6] border rounded w-3/4 px-5 h-12 gap-5 items-center"
            value={lead?.status}
          >
            <img
              className="w-10 h-10"
              src={statusIcons[lead?.status]}
              alt={lead?.status}
            />

            <input
              className=" appearance-none font-semibold cursor-default bg-[#F6F6F6] border-none  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="name"
              type="text"
              required
              readOnly
              value={lead?.status}
            />
          </div>
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Character
          </label>
          <div className="flex bg-[#F6F6F6] border rounded w-3/4 px-5 h-12 gap-5 items-center">
            <img
              className="w-10 h-10"
              src={leadCharacterEmoji[lead?.leadCharacter]}
              alt={lead?.leadCharacter}
            />
            <input
              className=" appearance-none font-semibold cursor-default bg-[#F6F6F6] border-none  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="name"
              type="text"
              required
              readOnly
              value={lead?.leadCharacter}
            />
          </div>
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Notes
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 h-24 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.notes}
          />
        </div>
        <div title={lead?.name} className="text-center cursor-pointer  truncate text-xl font-bold mb-8">
          More Info : {lead?.name}
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Client Location
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.clientLocation}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Client Job
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.clientJobOrBusiness}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Residential Details
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.clientResidentialDetails}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Client Purpose
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.clientPurpose}
          />
        </div>
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Client Requirement
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.clientRequirement}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-gray-700 text-2xl font-bold"
            htmlFor="name"
          >
            Cash/Loan
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default bg-[#F6F6F6] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="name"
            type="text"
            required
            readOnly
            value={lead?.paymentType}
          />
        </div>
      </form>
    </div>
  );
};

export default LeadDetail;
